var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCompanyOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_741_47120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 14C12.4555 14 14.75 11.7055 14.75 8.875C14.75 6.04454 12.4555 3.75 9.625 3.75C6.79454 3.75 4.5 6.04454 4.5 8.875C4.5 11.7055 6.79454 14 9.625 14Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18.5119C4.05424 16.3653 6.60125 15 9.625 15C12.6487 15 15.1958 16.3653 17 18.5119",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2116 10.1389L20.8813 11.7349C20.8975 11.7737 20.924 11.8072 20.9579 11.832C20.9918 11.8568 21.0318 11.8719 21.0736 11.8756L22.7878 12.0238C22.8333 12.0275 22.8767 12.0445 22.9125 12.0728C22.9483 12.1011 22.9748 12.1394 22.9889 12.1829C23.0029 12.2263 23.0037 12.2729 22.9912 12.3168C22.9787 12.3607 22.9535 12.3999 22.9187 12.4294L21.6182 13.5639C21.5866 13.5917 21.5631 13.6275 21.5502 13.6675C21.5373 13.7076 21.5355 13.7504 21.545 13.7914L21.9348 15.479C21.9451 15.5231 21.9422 15.5693 21.9264 15.6117C21.9107 15.6541 21.8828 15.691 21.8463 15.7177C21.8097 15.7444 21.7661 15.7598 21.7209 15.7619C21.6757 15.764 21.6309 15.7528 21.592 15.7296L20.1188 14.8359C20.083 14.8141 20.0419 14.8026 20 14.8026C19.9581 14.8026 19.917 14.8141 19.8812 14.8359L18.408 15.7296C18.3691 15.7528 18.3243 15.764 18.2791 15.7619C18.2339 15.7598 18.1903 15.7444 18.1537 15.7177C18.1172 15.691 18.0893 15.6541 18.0736 15.6117C18.0578 15.5693 18.0549 15.5231 18.0652 15.479L18.455 13.7914C18.4645 13.7504 18.4627 13.7076 18.4498 13.6675C18.4369 13.6275 18.4134 13.5917 18.3818 13.5639L17.0813 12.4294C17.0465 12.3999 17.0213 12.3607 17.0088 12.3168C16.9963 12.2729 16.9971 12.2263 17.0111 12.1829C17.0252 12.1394 17.0517 12.1011 17.0875 12.0728C17.1233 12.0445 17.1667 12.0275 17.2122 12.0238L18.9264 11.8756C18.9682 11.8719 19.0082 11.8568 19.0421 11.832C19.076 11.8072 19.1025 11.7737 19.1187 11.7349L19.7884 10.1389C19.8063 10.0976 19.8358 10.0625 19.8734 10.0378C19.911 10.0131 19.955 10 20 10C20.045 10 20.089 10.0131 20.1266 10.0378C20.1642 10.0625 20.1937 10.0976 20.2116 10.1389Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_741_47120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "var(--bg-surface)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCompanyOwner);
export default __webpack_public_path__ + "static/media/sidebarCompanyOwner.92b47f359c5c54132e80f75ff01d818f.svg";
export { ForwardRef as ReactComponent };